<template>
  <v-container fluid grid-list-sm v-if="result" class="search-results">
    <v-layout row wrap v-if="result.posts.length">
      <v-flex>
        <h3 class="title grey--text text--darken-1 pt-0">
          Found <strong v-html="result.count_total" />
          results for "<strong v-html="query" />"
        </h3>
      </v-flex>
      <v-flex>
        <div
          class="text-lg-right text-md-right text-sm-right text-xs-right"
          v-html="`${$store.getters.getLangKey('resultsPerPage')}:`" />
        <div class="text-lg-right text-md-right text-sm-right text-xs-right">
          <v-select
            class="results-per-page-dropdown pt-0"
            @input="getSearchResults()"
            :items="itemsPerPageDropdown"
            v-model="resultsPerPage"
          />
        </div>
      </v-flex>
    </v-layout>
    <v-layout row wrap v-else>
      <v-flex>
        <h3 class="title grey--text text--darken-1 pt-0">Nothing found
          for "<strong v-html="query" />". Maybe try another serach?</h3>
        <search-form />
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex>
        <vue-adsense ad-slot="9213118610" ad-format="auto" />
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex>
        <ol>
          <li v-for="(item, index) in result.posts" :key="index">
            <h3 class="subheading pt-1 pb-1">
              <v-chip label class="ml-0">{{ item.type.toUpperCase() }}</v-chip>
              <router-link
                v-if="item.type === 'post'"
                class="grey--text text--darken-2"
                :to="createPostUrl(item.date, item.slug)">{{ item.title_plain }}</router-link>
              <router-link
                v-else
                class="grey--text text--darken-2"
                :to="`${pageTopSlug}/${item.slug}`">{{ item.title_plain }}</router-link>
            </h3>
            <p
              v-html="cap(item.excerpt)"
              class="grey--text text--darken-2" />
            <div
              v-if="item.type === 'post'"
              v-html="`${$store.state.domain}${createPostUrl(item.date, item.slug)}`" />
            <div
              v-else
              v-html="`${$store.state.domain}${pageTopSlug}/${item.slug}`" />
          </li>
        </ol>
      </v-flex>
    </v-layout>
    <v-layout row wrap>
      <v-flex>
        <div class="text-xs-center" v-if="result.posts.length">
          <v-pagination
            router
            :color="$store.state.baseColor"
            :length.number="result.pages"
            @input="goTo()"
            v-model="page"
          />
        </div>
      </v-flex>
    </v-layout>
  </v-container>
</template>
<script>
  import Mixins from '../helpers/Mixins'
  import SearchForm from '../components/SearchForm.vue'

  export default {
    name: 'SearchResults',
    mixins: [
      Mixins
    ],
    components: {
      SearchForm
    },
    data () {
      return {
        query: null,
        resource (count, page, search) {
          return `?resource=get_search_results&count=${count}&page=${page}&search=${search}`
        },
        itemsPerPageDropdown: [5, 10, 15, 20, 25, 30],
        pageTopSlug: this.$store.state.pageTopSlug,
        resultsPerPage: null,
        result: null,
        page: 1
      }
    },
    watch: {
      '$route.params.query': function () {
        this.getSearchResults()
      },
      '$route.params.page': function () {
        this.getSearchResults()
      }
    },
    mounted () {
      this.resultsPerPage = this.itemsPerPageDropdown[1]
      this.getSearchResults()
    },
    methods: {
      /**
       * Go to URL on pager click
       * @method goTo
       * @return {void}
       */
      goTo () {
        this.$router.push({
          path: `/search/${this.page}/${this.query}`
        })
      },
      /**
       * Get the search results DTO from the API
       * @method getSearchResults
       * @return {void}
       */
      getSearchResults () {
        this.query = this.$route.params.query
        this.page = parseInt(this.$route.params.page, 10)
        const store = this.$store
        const getters = store.getters
        const ajax = store.state.events.ajax
        const base = getters.apiProxyUrl
        const url = `${base}${this.resource(this.resultsPerPage, this.page, this.query)}`
        this.$root.$emit(ajax, true)
        this.$http.post(url)
          .then((response) => {
            this.result = response.data
            this.setTitle(`${getters.getLangKey('searchResultsForTitle')} "${this.query}"`)
            this.$root.$emit(ajax, false)
          })
      }
    }
  }
</script>
<style>
.search-results ol
{
  list-style: inside none;
  padding: 0;
  margin: 0;
}

.search-results .results-per-page-dropdown.input-group
{
  display: inline-block;
  flex: initial;
  width: 64px;
}

.search-results p
{
  padding: 0;
  margin: 0;
}

.search-results ol div
{
  font-size: .9em;
  color: #909090;
  margin: 0 0 1em;
}
</style>



// WEBPACK FOOTER //
// src/pages/SearchResults.vue